<template>
  <div class="wrapper">
    <div class="head-container p-0">
      <div class="main">
        <div class="header">
          <div class="logo">
            <img src="../assets/theme/header.png">
          </div>
        </div>
      </div>
    </div>

    <div class="container p-0 mt-2">
      <div class="main">
        <div class="content">
          <TodayResult />
        </div>
      </div>
    </div>

    <HistoryResults class="mt-5" />

    <div class="footer">
      <div class="footer-inner">
        Copyright ©{{year}} - www.tvdowjones.com
      </div>
    </div>
  </div>
</template>
<script>
import TodayResult from './components/TodayResult.vue'
import moment from "@/moment"
import HistoryResults from './components/HistoryResults.vue'

export default {
  components: {
    TodayResult,
    HistoryResults
  },
  computed: {
    year() {
      return moment().format("YYYY")
    }
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background-color: #D9D9D9;
}

.banner {
  img {
    width: 100%;
    max-width: 100%;
  }
}

.wrapper {
  max-width: 950px;
  padding: 0;
  background-image: url('../assets/theme/bg.png');
  background-size: cover;
  background-color: #011C53;
  background-repeat: no-repeat;
  background-position: center bottom;
  margin-right: auto;
  margin-left: auto;
}

.header-space {
  height: 8px;
  margin-top: 5px;
  background-color: #FFF;
}

.footer {
  margin-top: 0px;

  .footer-inner {
    text-align: center;
    background-color: #007F36;
    padding: 15px;
    color: #FEFEFE;
  }
}

.container, .head-container {
  .main {
    width: 950px;
    max-width: 100%;
    margin: 0 auto;

    .header {
      background-color: #000000;
      border-bottom: 8px solid #007F36;

      .logo {
        img {
          width: 100%;
        }
      }
    }

    .content {
      margin-top: 5px;

      .banner {
        text-align: center;
        img {
          max-width: 80%;
        }
      }
    }
  }
}
</style>
